import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

import { formatNumber } from "../../utilities/helpers";

import Card from "react-bootstrap/Card";
import ListGroup from "react-bootstrap/ListGroup";

export default function IndividualTicketsChart({ data, jsonData }) {
  if (!data) return "";

  const boxOfficeTickets =
    jsonData.boxOfficeTicketQty + jsonData.compBoxOfficeTicketQty;

  const webSiteTickets = jsonData.onlineTicketQty;

  const options = {
    chart: {
      type: "bar",
      height: 39,
      margin: [0, 0, 0, 0], // top, right, bottom, left
      background: "#fcfcfd",
      plotBackgroundColor: "#fcfcfd",
    },
    title: {
      text: "",
    },
    credits: {
      enabled: false,
    },
    xAxis: {
      categories: [""],
      labels: {
        enabled: false,
        reversed: false,
      },
      stackLabels: {
        enabled: false,
      },
      lineWidth: 0,
      gridLineWidth: 0, // Disables grid lines on x-axis
      tickLength: 0,
      height: 40,
    },
    yAxis: {
      labels: {
        enabled: false,
        reversed: false,
      },
      stackLabels: {
        enabled: false,
      },
      min: 0,
      title: {
        text: "",
      },
      lineWidth: 0,
      gridLineWidth: 0, // Disables grid lines on y-axis
      tickLength: 0,
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      series: {
        stacking: "percent",
        dataLabels: {
          enabled: false,
        },
      },
    },
    series: [
      {
        name: "Website",
        data: [webSiteTickets],
      },
      {
        name: "Box Office",
        data: [boxOfficeTickets],
      },
    ],
  };

  return (
    <Card className="card--md stat-card card-with-border">
      <Card.Body className="d-flex-column flex-sm">
        <Card.Title as="h5">Individual Tickets</Card.Title>
        <HighchartsReact highcharts={Highcharts} options={options} />
        <ListGroup as="ul" variant="flush">
          <ListGroup.Item
            as="li"
            className="d-flex justify-content-between align-items-center border-bottom-0 small"
          >
            <span className="info-text flex-sm info-text-dot info-text-dot--primary">
              Website
            </span>
            <span className="fw-medium">{formatNumber(webSiteTickets)}</span>
          </ListGroup.Item>
          <ListGroup.Item
            as="li"
            className="d-flex justify-content-between align-items-center border-bottom-0 small"
          >
            <span className="info-text flex-sm info-text-dot info-text-dot--tertiary">
              Box Office
            </span>
            <span className="fw-medium">{formatNumber(boxOfficeTickets)}</span>
          </ListGroup.Item>
          <ListGroup.Item className="d-flex justify-content-between align-items-center small mt-auto">
            <span className="fw-bold">Total</span>
            <span className="fw-bold">
              {formatNumber(boxOfficeTickets + webSiteTickets)}
            </span>
          </ListGroup.Item>
        </ListGroup>
      </Card.Body>
    </Card>
  );
}
